var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5547,
    cy: 28.1445,
    r: 26.5,
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9325_1506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.746 14.9688H21.3633C17.3333 14.9688 14.0547 18.2473 14.0547 22.2774V34.6603C14.0547 38.6901 17.3333 41.9687 21.3633 41.9687H33.7462C37.776 41.9687 41.0546 38.6901 41.0546 34.6603V22.2774C41.0546 18.2473 37.776 14.9688 33.746 14.9688ZM39.4718 34.6603C39.4718 37.8173 36.9033 40.3858 33.746 40.3858H21.3633C18.2061 40.3858 15.6375 37.8173 15.6375 34.6603V22.2774C15.6375 19.1201 18.2061 16.5516 21.3633 16.5516H33.7462C36.9033 16.5516 39.4718 19.1201 39.4718 22.2774V34.6603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5545 21.0859C23.4836 21.0859 20.1719 24.3977 20.1719 28.4685C20.1719 32.5394 23.4836 35.8511 27.5545 35.8511C31.6253 35.8511 34.9371 32.5394 34.9371 28.4685C34.9371 24.3977 31.6253 21.0859 27.5545 21.0859ZM27.5545 34.2683C24.3566 34.2683 21.7547 31.6666 21.7547 28.4685C21.7547 25.2707 24.3566 22.6688 27.5545 22.6688C30.7525 22.6688 33.3542 25.2707 33.3542 28.4685C33.3542 31.6666 30.7525 34.2683 27.5545 34.2683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1136 18.4639C33.9106 18.4639 32.9321 19.4425 32.9321 20.6453C32.9321 21.8483 33.9106 22.827 35.1136 22.827C36.3166 22.827 37.2953 21.8483 37.2953 20.6453C37.2953 19.4423 36.3166 18.4639 35.1136 18.4639ZM35.1136 21.244C34.7836 21.244 34.515 20.9753 34.515 20.6453C34.515 20.3151 34.7836 20.0467 35.1136 20.0467C35.4438 20.0467 35.7124 20.3151 35.7124 20.6453C35.7124 20.9753 35.4438 21.244 35.1136 21.244Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9325_1506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(14.0547 14.9688)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.9ce07464a268303448359e11ee9583a4.svg";
export { ForwardRef as ReactComponent };